import { render, staticRenderFns } from "./FlagData.vue?vue&type=template&id=462ab3a6&scoped=true&"
import script from "./FlagData.vue?vue&type=script&lang=js&"
export * from "./FlagData.vue?vue&type=script&lang=js&"
import style0 from "./FlagData.vue?vue&type=style&index=0&id=462ab3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ab3a6",
  null
  
)

export default component.exports